import { createAsyncThunk } from "@reduxjs/toolkit";
import apiService from "../../../../services/apiService/api/aiChat";
import { AI_CHAT_FLOW_SLICE_NAME } from "../../sliceConstants";

const aiChatThunkActions = {
  getUserSearches: createAsyncThunk(
    `${AI_CHAT_FLOW_SLICE_NAME}/getUserSearches`,
    async (payload, { rejectWithValue }) => {
      try {
        const res = await apiService.getUserSearches(payload);
        return res || {};
      } catch (err) {
        return rejectWithValue(err);
      }
    }
  ),
  getChats: createAsyncThunk(
    `${AI_CHAT_FLOW_SLICE_NAME}/getChats`,
    async (payload, { rejectWithValue }) => {
      try {
        const res = await apiService.getChats(payload);
        return res || {};
      } catch (err) {
        return rejectWithValue(err);
      }
    }
  ),
  sendFeedback: createAsyncThunk(
    `${AI_CHAT_FLOW_SLICE_NAME}/sendFeedback`,
    async (payload, { rejectWithValue }) => {
      try {
        const res = await apiService.sendFeedback(payload);
        return res || {};
      } catch (err) {
        return rejectWithValue(err);
      }
    }
  ),
  getRealTimeDate: createAsyncThunk(
    `${AI_CHAT_FLOW_SLICE_NAME}/getRealTimeDate`,
    async (payload, { rejectWithValue }) => {
      try {
        const res = await apiService.getRealTimeDate(payload);
        return res || {};
      } catch (err) {
        return rejectWithValue(err);
      }
    }
  ),
  getPopularSearchesList: createAsyncThunk(
    `${AI_CHAT_FLOW_SLICE_NAME}/popularSearches`,
    async (payload, { rejectWithValue }) => {
      try {
        const res = await apiService.getPopularSearchesList(payload);
        return res || {};
      } catch (err) {
        return rejectWithValue(err);
      }
    }
  ),
};
export default aiChatThunkActions;
